import React from "react";
import GlobalFunctions from "../Services/GlobalFunctions";

const TablaAmortizado = (params) => {
  const glob = new GlobalFunctions();

  function calcularCostoServicioPendiente() {
    let fechaAbonoInteres = "";
    let datos = {
      saldo: 0,
      interes: 0,
      totalPagar: 0,
    };
    if (params.cliente.prestamo.valorprestamo != "") {
      if (params.cliente.prestamo.amortizado) {
        var fechaInicio = null;
        if (params.abonos.length > 0) {
          params.abonos.forEach((element) => {
            if (fechaAbonoInteres < element.fecha_abono_interes) {
              fechaAbonoInteres = element.fecha_abono_interes;
              datos.saldo = element.nuevo_saldo;
            }
          });
          fechaInicio = new Date(fechaAbonoInteres).getTime();
        } else {
          fechaInicio = new Date(params.cliente.prestamo.fecha_prest).getTime();
          datos.saldo = params.cliente.prestamo.valorprestamo;
        }
        var fechaHoy = new Date().getTime();
        var diff = fechaHoy - fechaInicio;
        let diasTransc = diff / (1000 * 60 * 60 * 24) - 1;
        //Interes diario
        let intDiario = params.cliente.prestamo.interes / 100 / 30;
        let intDiarioPesos = (datos.saldo * intDiario).toFixed(0);
        datos.interes = intDiarioPesos * diasTransc;
        datos.totalPagar = datos.saldo + datos.interes;
      }
    }
    return datos;
  }

  return (
    <div
      className="modal fade bd-example-modal-lg"
      id="modalTableAmortizado"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header navBarFondo">
            <h5 style={{ color: "white" }} className="modal-title ">
              Detalle crédito{" "}
              {params.cliente.nombreCompleto}
            </h5>
            <svg
              data-dismiss="modal"
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              fill="currentColor"
              className="bi bi-x-square"
              viewBox="0 0 16 16"
              style={{ marginTop: "-0.8em", cursor: "pointer", color: "white"}}
            >
              <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
            </svg>
          </div>
          <div className="table-responsive">
            <table className="table table-sm centerCelda">
              <thead>
                <tr className="align-middle ">
                  <th scope="row">Fecha préstamo</th>
                  <td style={{ whiteSpace: "nowrap" }}>
                    {params.cliente.prestamo.fecha_prest}
                  </td>
                </tr>
                <tr className="align-middle">
                  <th scope="row">Valor Prestamo</th>
                  <td>
                    {glob.formatNumber(
                      params.cliente.prestamo.valorprestamo!="" ? params.cliente.prestamo.valorprestamo : 0
                    )}{" "}
                  </td>
                </tr>
                <tr className="align-middle ">
                  <th scope="row">Vencimiento</th>
                  <td style={{ whiteSpace: "nowrap" }}>
                    {params.cliente.prestamo.vencimiento}
                  </td>
                </tr>
                <tr className="align-middle">
                  <th scope="row">Costo servicio</th>
                  <td>{params.cliente.prestamo.interes}%. </td>
                </tr>
              </thead>
            </table>
            <table className="table table-sm centerCelda">
              <thead>
                <tr className="align-middle">
                  <th
                    colSpan="5"
                    style={{ fontWeight: "bold", fontStyle: "italic" }}
                    className="rounded"
                  >
                    Abonos
                  </th>
                </tr>
                <tr className="align-middle">
                  <th className="fondoCelda centerCelda rounded">Fecha</th>
                  <th className="fondoCelda centerCelda rounded">
                    Abono costo servicio
                  </th>
                  <th className="fondoCelda centerCelda rounded">
                    Abono a capital
                  </th>
                  <th className="fondoCelda centerCelda rounded">
                    Total valor cuota
                  </th>
                  <th className="fondoCelda centerCelda rounded">
                    Nuevo saldo
                  </th>
                  <th className="fondoCelda centerCelda rounded">Cuota n°</th>
                  <th className="fondoCelda centerCelda rounded">
                    Fecha corte abono interes
                  </th>
                  <th className="fondoCelda centerCelda rounded">Asesor</th>
                </tr>
              </thead>
              <tbody>
                {params.abonos.map((item) => {
                  return (
                    <tr key={item.id} className="centerCelda">
                      <td>{item.fecha}</td>
                      <td>{glob.formatNumber(item.abono_interes)}</td>
                      <td>{glob.formatNumber(item.abono_capital)}</td>
                      <td>{glob.formatNumber(item.valor_abono)}</td>
                      <td>{glob.formatNumber(item.nuevo_saldo)}</td>
                      <td>{item.altura_cuota}</td>
                      <th style={{ whiteSpace: "nowrap" }}>
                        {item.fecha_abono_interes}
                      </th>
                      <td>{item.asesor}</td>
                    </tr>
                  );
                })}
              </tbody>
              <thead>
                <tr className="align-middle">
                  <th colSpan="2" className="fondoCelda centerCelda rounded">
                    Costo servicio a la fecha
                  </th>
                  <th className="fondoCelda centerCelda rounded">
                    {glob.formatNumber(
                      calcularCostoServicioPendiente().interes.toFixed(0)
                    )}
                  </th>
                  <th
                    style={{ color: "green" }}
                    className="fondoCelda centerCelda rounded"
                  >
                    Total a pagar
                  </th>
                  <th
                    style={{ color: "green" }}
                    className="fondoCelda centerCelda rounded"
                  >
                    {glob.formatNumber(
                      calcularCostoServicioPendiente().totalPagar.toFixed(0)
                    )}
                  </th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TablaAmortizado;
